import React from 'react'
import FirstSection from '../Components/FirstSection/FirstSection'
import SeconedSection from '../Components/SeconedSection/SeconedSection'
import ThirdSection from '../Components/ThirdSection/ThirdSection'
import FourthSection from '../Components/FourthSection/FourthSection'
import FifthSection from '../Components/FifthSection/FifthSection'
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup'

function Home() {
  
  return (
    <div className='home'>
      <FirstSection/>
      <SeconedSection/>
      <ThirdSection/>
      <FourthSection/>
      <FifthSection/>
    </div>
  )
}

export default Home
